module.exports = __webpack_public_path__ + "static/frontUserNew/img/template-customer-style.a7c11911.gif";